import React from "react";
import { StyledSpacer } from "./styled";

function Spacer({ children }) {
  return <StyledSpacer>{children}</StyledSpacer>;
}

export default Spacer;
